import React, { useMemo, useState } from 'react';
import ProductCard from '../components/ProductCard';
import Topbar from '../components/Topbar';
import EmptyState from '../components/EmptyState';
import ProductDetailModal from '../components/ProductDetailModal';
import { useApp } from '../context/AppContext';

const BuyNow = ({ onDeposit }) => {
  const { products } = useApp();
  const [sort, setSort] = useState('NEWEST_FIRST');
  const [inStockOnly, setInStockOnly] = useState(false);
  const [q, setQ] = useState('');
  const [selected, setSelected] = useState(null);

  const list = useMemo(() => {
    let arr = [...products];
    if (inStockOnly) arr = arr.filter((p) => (p.stock || 0) > 0);
    if (q.trim()) arr = arr.filter((p) => p.name.toLowerCase().includes(q.trim().toLowerCase()));
    if (sort === 'PRICE_LOW') arr.sort((a, b) => a.usdt - b.usdt);
    else if (sort === 'PRICE_HIGH') arr.sort((a, b) => b.usdt - a.usdt);
    else if (sort === 'STOCK_HIGH') arr.sort((a, b) => (b.stock || 0) - (a.stock || 0));
    return arr;
  }, [products, sort, inStockOnly, q]);

  const storeEmpty = products.length === 0;
  const filteredEmpty = !storeEmpty && list.length === 0;

  return (
    <div>
      <Topbar
        count={list.length}
        sort={sort} setSort={setSort}
        inStockOnly={inStockOnly} setInStockOnly={setInStockOnly}
        onDeposit={onDeposit}
      />
      <div className="px-8 py-6">
        {!storeEmpty && (
          <div className="mb-5 flex items-center gap-3">
            <div className="flex-1 relative">
              <input
                value={q}
                onChange={(e) => setQ(e.target.value)}
                placeholder="$ search product name…"
                className="w-full bg-[#0a0a0a] border border-[#1f1f1f] rounded-md px-3 py-2 text-[13px] text-[#e6e6e6] font-mono outline-none focus:border-[#22c55e] transition-colors placeholder:text-[#4a4a4a]"
              />
            </div>
            <div className="text-[10px] tracking-[0.25em] text-[#5a5a5a] font-mono">
              {list.length} RESULT{list.length !== 1 ? 'S' : ''}
            </div>
          </div>
        )}

        {storeEmpty ? (
          <EmptyState variant="coming-soon" />
        ) : filteredEmpty ? (
          <EmptyState variant="filter" title="NO PRODUCTS MATCH" subtitle="Try clearing your search or filter." />
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
            {list.map((p) => (
              <ProductCard key={p.id} product={p} onSelect={setSelected} />
            ))}
          </div>
        )}
      </div>

      <ProductDetailModal
        product={selected}
        open={!!selected}
        onClose={() => setSelected(null)}
        onDeposit={onDeposit}
      />
    </div>
  );
};

export default BuyNow;
